module.exports = __webpack_public_path__ + "static/img/la.e0ec1b4e.svg";